export default {
  title: "Tutellus POAPs",
  description: "On-chain badges from Tutellus events and courses, in your wallet.",
  back: "Back",
  card: {
    mint: "Mint",
    detail: "View detail",
    enterCode: "Event code",
    description: "Description",
    detailsTitle: "Details",
    openSea: "View on OpenSea",
    share: "Share",
    copyText: "Copy link",
    metadata: {
      contract: "Contract",
      tokenStandard: "Standard",
      blockchain: "Blockchain",
      tokenId: "Token ID",
      type: "Type",
      minted: "Minted",
    },
  },
  page: {
    titleMint: "Mint your POAP",
    mintCTA: "Mint POAP",
    mintingCTA: "Minting...",
    connectWallet: "Connect Wallet",
    footerInfo: {
      title: "How to get this POAP",
    },
  },
}
